<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import VisualSuccess from '../components/VisualSuccess.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import ButtonSecondary from '@/shared/components/button/ButtonSecondary.vue';
import ChevronRightSVG from '@shared/assets/icon/chevron-right.svg';
import AddIcon from '@shared/assets/icon/add.svg';
import router from '@/router';


const commissionAnother = () => {
  router.push({ name: 'StartupSolShare' });
};

const done = () => {
  router.push({ name: 'ComWelcome' });
};

</script>

<template>
  <ProgressFrame pageClass="subsection-page">
    <div class="content">
      <VisualSuccess>
        <template #title>Great work!</template>
      </VisualSuccess>
      <div class="action-container">
        <ButtonSecondary block class="cta-button" @click="commissionAnother" data-tn="commission-another-btn">
          <template #iconLeft>
            <AddIcon class="add-icon" />
          </template>
          Commission another SolShare
        </ButtonSecondary>
        <ButtonPrimary block class="cta-button" @click="done" data-tn="done-for-today-btn">
          Done for today
          <template #iconRight>
            <ChevronRightSVG class="chevron-right-icon" />
          </template>
        </ButtonPrimary>
      </div>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.content {
  text-align: center;
  margin-top: 3rem;
}
.action-container {
  width: 100%;
  margin-top: @margin-top-end-of-page-section;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
